const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  seqId: state => state.user.seqId,
  //编辑器

  //页面标题
  pageTitle: state =>  state.widget.header.title,
  //页面背景
  pageBg: state =>  state.widget.header.bgColor,
  //当前选中组件ID
  currentWidgetId: state => state.widget.currentWidgetId,
  //组件列表参数信息
  widgetsDataList: state => state.widget.widgetsDataList,
}
export default getters
